import { useEffect } from "react";
import { getCurrentSite, switchSite } from "../utils/SiteUtils";
import { useCountryRedirectContext } from "../components/CountryRedirection/CountryRedirectContext";
import { StringParam, useQueryParam } from "use-query-params";

const autoRedirectQueryParam = "a";

export default function useAutoSiteRedirect() {
  const site = getCurrentSite();
  const {
    site: userSite,
    isAvailable: isAvailableOnUserSite,
    url: userSiteUrl
  } = useCountryRedirectContext();
  const [autoSiteRedirect] = useQueryParam(autoRedirectQueryParam, StringParam);

  useEffect(() => {
    console.debug(
      "autoSiteRedirect",
      !!autoSiteRedirect,
      site,
      userSite,
      isAvailableOnUserSite,
      userSiteUrl
    );
    if (
      autoSiteRedirect &&
      userSite &&
      isAvailableOnUserSite &&
      userSite !== site &&
      userSiteUrl
    ) {
      const url = new URL(userSiteUrl);
      url.searchParams.delete(autoRedirectQueryParam);
      switchSite(userSite, url);
    }
  }, [autoSiteRedirect, userSite, userSiteUrl, site, isAvailableOnUserSite]);
}
